import ListOfNotches from 'components/ListOfNotches';

function GroupedList({
    items = [],
    settings = [],
    onClickHandler
}) {
    if (!items.length){
        return null;
    }

    return (
        <>
            {items.map((item) => (
                <div key={item.uid} className="mb-3">
                    <div style={{ paddingLeft: '16px' }}>
                        <h4 className="text-muted">{item.title}</h4>
                    </div>
                    
                    <ListOfNotches
                        items={item.items}
                        settings={settings}
                        onClickHandler={onClickHandler}
                    />
                </div>
            ))}
        </>
    );
};

export default GroupedList;
